import axios from "./index";
import { firestoreOperationsDb } from "../firebase";

export const fetchAuthCredentials = async (email, domain = "Nomadic care") => {
  const response = await axios.post("/loginWithGoogleAuth", { email, domain });
  return response;
};

export const getVerifyGoogleCredentials = async (otp, formattedKey) => {
  const response = await axios.post("/verifyGoogleAuthKey", {
    otp,
    formattedKey,
  });
  return response;
};

// Cache the key in memory so we only hit Firestore once per page load
let _cachedOtpApiKey = null;

async function getOtpApiKey() {
  if (_cachedOtpApiKey) return _cachedOtpApiKey;
  const snap = await firestoreOperationsDb
    .collection("_config")
    .doc("otpSecurity")
    .get();
  if (!snap.exists) throw new Error("OTP config not found in Firestore");
  const key = snap.data().apiKey;
  if (!key) throw new Error("apiKey missing in _config/otpSecurity");
  _cachedOtpApiKey = key;
  return key;
}

export const sendCarerSmsOtp = async (phoneNumber) => {
  const apiKey = await getOtpApiKey();
  const response = await axios.post(
    "/sendOtp",
    { phone: phoneNumber, source: "web" },
    { headers: { "x-api-key": apiKey } }
  );
  return response;
};

export const verifyCarerSmsOtp = async (phoneNumber, otp) => {
  const apiKey = await getOtpApiKey();
  const response = await axios.post(
    "/verifyOtp",
    { phone: phoneNumber, code: otp, source: "web" },
    { headers: { "x-api-key": apiKey } }
  );
  return response;
};

export const documentTitleFetch = async (url) => {
  const response = await axios.get(
    `https://australia-southeast1-nc-events-uat2.cloudfunctions.net//fetchTitleApi?url=${url}`
  );

  return response;
};
